(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/high-five-next-race/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/high-five-next-race/assets/javascripts/prescript.js');

'use strict';

svs.racing = svs.racing || {};
svs.racing.high_five_next_race = svs.racing.high_five_next_race || {};

 })(window);